export const defaultStyle = {
    mainMobilUlLI:"mainMobilUlLI",
    mainMobilUlBtn:"mainMobilUlBtn",
    mainMobilUlLIink:"mainMobilUlLIink",
    mainMobilUlSUbmenu:"mainMobilUlSUbmenu",
    mainMobiSUbmenuDiv:"mainMobiSUbmenuDiv",
    mainMobiSUbmenuSubWrap:"mainMobiSUbmenuSubWrap",
    mainMobiSUbmSubWrapIn:"mainMobiSUbmSubWrapIn",
    mainMobiSUbmenuSubIcon:"mainMobiSUbmenuSubIcon",
    mainMobiSUbmSubWrapIn2:"mainMobiSUbmSubWrapIn2",
    mainMobiSUbmSubWrapIn2In:"mainMobiSUbmSubWrapIn2In",
}